import React, { useEffect, useState } from 'react'
import Neft from '../../lib/paymentScreen/Neft'
import UpiOneTimeMandate from '../../lib/paymentScreen/UpiOneTimeMandate'
import NetBanking from '../../lib/paymentScreen/NetBanking'
import { Box, Grid, LinearProgress, Tab, Tabs, Theme, Typography,useTheme } from '@mui/material'
import { UPI_LIMIT } from '../../utils/constant'
import { getMandateCreationDetails } from '../../redux-store/actions/investorProfile'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { MandateCreation } from '../../redux-store/types/investorProfile'
import { GetOrderPreviewResponseBody } from '../../redux-store/types/cart'
import { RootStateType } from '../../redux-store/reducers'
import Cheque from '../../lib/paymentScreen/Cheque'
import OneTimeMandate from '../../lib/paymentScreen/OneTimeMandate'
import { tabsArray } from '../../lib/paymentScreen'

interface RouterStateData {
    clientCode?: string
    portfolioId?: string
    payable_amount?: number
    orderId?: string
}

export default function IndividualPaymentScreen(): JSX.Element {
    const dispatch = useDispatch();
    const history = useHistory();
     const theme = useTheme();

    const routerStateObj = history.location.state as RouterStateData
    // const tabsArray = ["Net Banking", "UPI Mandate", "One Time Mandate", "NEFT/RTGS", "Cheque"]

    const { investorClientId = "" } = useSelector((store: RootStateType) => store.id);

    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    type Tab = "Net Banking" | "UPI Mandate" | "One Time Mandate" | "NEFT/RTGS" | "Cheque"
    const [activeTab, setActiveTab] = useState<Tab>("Net Banking")
    const [isLoading, setLoading] = useState<boolean>(false)
    const [bankDetails, setBankDetails] = useState<MandateCreation[]>([])

    const orderPreviewData = {
        payable_amount: routerStateObj?.payable_amount ?? 0,
        orderId: routerStateObj?.orderId ?? "",
        isIndividualPayment: true
    }

    const fetchBankDetails = async () => {
        try {
            setLoading(true);
            const response = await (dispatch(getMandateCreationDetails({ clientCode: routerStateObj?.clientCode ? (routerStateObj?.clientCode) : investorClientId, portfolioId: routerStateObj?.portfolioId ? (routerStateObj?.portfolioId) : selectedPortfolio?.value })) as unknown as any)
            setBankDetails(response ?? []);
        } catch (e) {
            console.log('error', e);
        } finally {
            setLoading(false);
        }
    }

    const handleTabChange = (event: React.SyntheticEvent, selectedTabIndex: number) => {
        setActiveTab(tabsArray[selectedTabIndex] as Tab);
    };

    useEffect(() => {
        fetchBankDetails()
    }, []);

    return (
        <Grid
            item
            xs={12}
            lg={8}
            order={{ xs: 2, lg: 1 }}
        >
            <Box
                sx={(theme: Theme) => ({
                    borderRadius: "20px",
                    padding: "25px 30px 30px 30px",
                    backgroundColor: theme.palette.common.white,
                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                })}
            >
                <Typography
                    variant="h2"
                    sx={(theme: Theme) => ({
                        color: theme.palette.text.primary,
                        lineHeight: "25px",
                        letterSpacing: "0.01px"
                    })}
                >
                    Choose Payment Mode
                </Typography>
                {
                    isLoading ? (
                        <Box sx={{ marginTop: "20px" }}>
                            <LinearProgress />
                        </Box>
                    ) : (
                        <Box sx={{ marginTop: "20px" }}>
                            <Tabs
                                value={tabsArray.indexOf(activeTab)}
                                onChange={handleTabChange}
                                 sx={{
                                    borderBottom: 1,
                                    borderColor: "divider",
                                }}
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                {tabsArray.map((tab: string) => (
                                    <Tab
                                        key={tab}
                                        label={tab}
                                        sx={{
                                            ...theme.typography.overline_600
                                        }}
                                        disabled={tab === 'UPI Mandate' && orderPreviewData.payable_amount > UPI_LIMIT}
                                    />
                                ))}
                            </Tabs>
                            <Box sx={{ marginTop: "20px" }}>
                                {activeTab === "Net Banking" && (
                                    <NetBanking
                                        bankDetailsData={bankDetails ?? []}
                                        orderPreviewData={orderPreviewData}
                                    />
                                )}
                                {activeTab === "UPI Mandate" && (
                                    <UpiOneTimeMandate
                                        bankDetailsData={bankDetails ?? []}
                                        orderPreviewData={orderPreviewData}
                                    />
                                )}
                                {activeTab === "One Time Mandate" && (
                                    <OneTimeMandate
                                        bankDetailsData={bankDetails ?? []}
                                        orderPreviewData={orderPreviewData}
                                    />
                                )}
                                {activeTab === "NEFT/RTGS" && (
                                    <Neft
                                        bankDetailsData={bankDetails ?? []}
                                        orderPreviewData={orderPreviewData}
                                    />
                                )}
                                {activeTab === "Cheque" && (
                                    <Cheque
                                        bankDetailsData={bankDetails ?? []}
                                        orderPreviewData={orderPreviewData}
                                    />
                                )}
                            </Box>
                        </Box>
                    )
                }
            </Box>
        </Grid>
    )
}
